import useClerkMetadata from "features/User/hooks/useClerkMetadata";

export const useResearchHubMode = () => {
  const { userMetadata, updateUserMetadata } = useClerkMetadata();

  const isResearchHubBannerHidden = Boolean(
    userMetadata?.is_research_hub_banner_hidden
  );

  const dismissResearchHubBanner = () => {
    updateUserMetadata({
      is_research_hub_banner_hidden: true,
    });
  };

  return {
    isResearchHubBannerHidden,
    dismissResearchHubBanner,
  };
};
